var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GolfParkImages"},[_c('div',{staticClass:"homepage"},[_c('b-row',_vm._l((_vm.acf.acf.images.slice(0,4)),function(item,index){return _c('b-col',{key:index,staticClass:"imageCol",style:({ backgroundImage: 'url(' + item.image + ')' }),attrs:{"lg":"3"}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }